import React from 'react'
import { ReflectionPickerDataQueryResult } from '@graphql/queries/__generated__/product-details.generated'
import _ from 'lodash'
import { getProductUrl } from '../../urls'

export const extractReflectionMeta = (
  data: ReflectionPickerDataQueryResult['data']['reflectionDetails'] | any,
  images?: { url?: string }[] | null
) => {
  const spec = data.reflection
  const description = spec.product.metaDescription || spec.description.replace(/<\/?[^>]+(>|$)/g, '').slice(0, 150)
  const specUrl = getProductUrl(spec.slug, spec.pk)
  const custom = [
    <meta
      key='product:price:amount'
      name='product:price:amount'
      content={spec.product.priceRange?.discount.min.toString()}
    />,
    <meta key='product:price:currency' name='product:price:currency' content={spec.product.priceRange?.currency} />,
    <meta
      key='product:isAvailable'
      name='product:isAvailable'
      content={!spec.product.isInStock ? 'in stock' : 'out off stock'}
    />,
    <meta key='product:category' name='product:category' content={spec.name} />,
  ]
  if (!spec.skipCanonical) {
    custom.push(<link key='product:canonical' rel='canonical' href={window.location.origin + specUrl} />)
  }
  return {
    custom,
    description: description,
    keywords: spec.product.keywords,
    image: images ? window.location.origin + images[0]?.url : '',
    type: 'product.item',
    url: window.location.href,
  }
}
export const getAttributesFromProduct = (
  properties: { valueName: string; attributeName: string }[]
): {
  name: string
  values: string[]
}[] => {
  const attributes = []
  properties.forEach(prop => {
    const attrIndex = attributes.findIndex(attr => attr.name === prop.attributeName)
    if (attrIndex > -1) {
      attributes[attrIndex].values = _.uniq([...attributes[attrIndex].values, prop.valueName])
    } else {
      attributes.push({ name: prop.attributeName, values: [prop.valueName] })
    }
  })
  return attributes
}
